/* __next_internal_client_entry_do_not_use__ QuickAddBase auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense, useContext } from "react";
import { LazyEncapsulatedQuickAdd } from "@faire/retailer/components/QuickAdd/LazyEncapsulatedQuickAdd";
import { QuickAddTrackingEventsContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddTrackingEventsContext/QuickAddTrackingEventsContext";
import { useProductTileContainerRef } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/ProductTileContainerRefContextProvider";
import { canQuickAdd } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/useCanQuickAdd";
import { useContainerRef } from "../../useContainerRef";
import { useFaireProtection } from "@faire/retailer/stores/domain/FaireProtection/useFaireProtection";
export var QuickAddBase = function(param) {
    var _param_data = param.data, productToken = _param_data.productToken, quickAdd = _param_data.quickAdd, brandToken = _param_data.brandToken, state = _param_data.state;
    var _useContext = useContext(QuickAddTrackingEventsContext), onQuickAddButtonClick = _useContext.onQuickAddButtonClick, onQuickAddSubmit = _useContext.onQuickAddSubmit, onChooseOptionClick = _useContext.onChooseOptionClick, onChooseOptionQuantityUpdateSubmit = _useContext.onChooseOptionQuantityUpdateSubmit, getCartItemTokenByProductToken = _useContext.getCartItemTokenByProductToken;
    var containerRef = useProductTileContainerRef();
    var currentContainerRef = useContainerRef(containerRef);
    var isBrandTokenForbidden = useFaireProtection().isBrandTokenForbidden;
    var isFaireProtectionRestricted = isBrandTokenForbidden(brandToken !== null && brandToken !== void 0 ? brandToken : "");
    var canQuickAddProduct = canQuickAdd(state, quickAdd);
    if (!canQuickAddProduct) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        style: {
            position: "absolute",
            right: "0px"
        },
        "data-test-id": "composable-quick-add",
        children: /*#__PURE__*/ _jsx(Suspense, {
            fallback: null,
            children: /*#__PURE__*/ _jsx(LazyEncapsulatedQuickAdd, {
                productToken: productToken,
                quickAdd: quickAdd,
                brandToken: brandToken,
                imageContainerRef: currentContainerRef ? {
                    current: currentContainerRef
                } : undefined,
                onQuickAddClick: onQuickAddButtonClick,
                onQuickAddSubmit: onQuickAddSubmit,
                onChooseOption: onChooseOptionClick,
                onChooseOptionQuantityUpdate: onChooseOptionQuantityUpdateSubmit,
                getCartItemTokenByProductToken: getCartItemTokenByProductToken,
                disableQuickAddWithFaireProtectionTooltip: isFaireProtectionRestricted,
                showModalOnClick: true
            }, "".concat(productToken, "-encapsulated-quick-add"))
        }, "".concat(productToken, "-suspense"))
    });
};
